const SimpleLightbox = require('simple-lightbox');

function handleLink(e) {
    const container = document.createElement('div');
    const imgObj = document.createElement('img');
    container.style.position = 'relative';
    // container.style.overflow = 'hidden';
    // container.style.paddingTop = '52.25%';
    container.style.width = '800px';
    container.style.maxWidth = '100%';
    container.style.display = 'flex';
    container.style.alignItems = 'center';
    container.style.justifyContent = 'center';
    container.style.alignContent = 'center';

    imgObj.style.position = 'relative';
    imgObj.style.top = 0;
    imgObj.style.left = 0;
    // imgObj.style.width = '100%';
    // imgObj.style.height = '100%';
    imgObj.style.width = 'auto';
    imgObj.style.maxWidth = '90%';
    imgObj.style.height = 'auto';
    imgObj.style.maxHeight = '90vh';
    imgObj.style.border = 'none';

    imgObj.setAttribute('src', e.currentTarget.href);

    container.appendChild(imgObj);

    e.preventDefault();
    e.stopPropagation();

    SimpleLightbox.open({
        content: container,
        elementClass: 'js-lightbox',
        closeBtnClass: 'product__lightbox__close',
    });
}

document.querySelectorAll('.js-case-study-lightbox-link').forEach((link) => {
    link.addEventListener('click', handleLink);
    link.addEventListener('tap', handleLink);
});
